import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useNotify from "hooks/useNotify";
import profileApi from "api/profile";
import { actions } from "store/actions";

function useServices({}) {
  const userDetails = useSelector((state) => state.userDetails || {});

  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [isEditServices, setIsEditServices] = useState(false);

  const { notifyError, notifySuccess } = useNotify();

  const onEditServices = async (values) => {
    try {
      setIsLoading(true);
      const vendorId = userDetails?.vendorId;
      const agencyId = userDetails?.agencyId;
      const { serviceRates = [], services = [] } = values;

      let aggServiceRates = Object.keys(serviceRates).reduce(
        (acc, serviceId) => {
          Object.keys(serviceRates[serviceId]).forEach((langPairKey) => {
            serviceRates[serviceId][langPairKey].forEach((rateType) => {
              const rateValue =
                rateType.withRate && rateType.rate !== undefined
                  ? Number(rateType.rate)
                  : undefined;

              const capacityValue =
                rateType.withCapacity && rateType.capacity !== undefined
                  ? Number(rateType.capacity)
                  : undefined;

              const hasRateValue = rateValue !== undefined && rateValue !== 0;
              const hasCapacityValue =
                capacityValue !== undefined && capacityValue !== 0;

              const skip =
                !rateType.withRate && !rateType.withCapacity
                  ? false
                  : (rateType.withRate && !hasRateValue) ||
                    (rateType.withCapacity && !hasCapacityValue);

              if (skip) return;

              const hasRate =
                rateType.withRate && rateValue !== undefined && rateValue !== 0
                  ? { rate: rateValue }
                  : {};

              const hasCapacity =
                rateType.withCapacity &&
                capacityValue !== undefined &&
                capacityValue !== 0
                  ? { capacity: capacityValue }
                  : {};

              const hasFromLanguages =
                rateType.hasLanguages && rateType.isPair
                  ? { fromLanguage: rateType.fromLanguage }
                  : {};

              const hasToLanguages = rateType.hasLanguages
                ? { toLanguage: rateType.toLanguage }
                : {};

              acc.push({
                rateId: rateType.rateId,
                ...hasRate,
                ...hasCapacity,
                ...hasFromLanguages,
                ...hasToLanguages,
              });
            });
          });
          return acc;
        },
        []
      );

      const payload = {
        serviceRates: aggServiceRates,
        services,
      };

      if (vendorId) {
        await profileApi.updateVendorServices(vendorId, payload);
      } else {
        await profileApi.updateAgencyServices(agencyId, payload);
      }

      const userData = await profileApi.getUserProfileByIdApi(userDetails?.id);
      dispatch(actions.setUserDetails(userData));
      dispatch(actions.getRates());
      setIsEditServices(false);
      notifySuccess("Has been updated successfully");
    } catch (err) {
      console.error(err);
      notifyError(err?.data?.error ?? err?.message ?? "Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  };

  const resetOnUnmount = () => {};
  useEffect(() => {
    return () => {
      resetOnUnmount();
    };
  }, []);

  return {
    isEditServices,
    setIsEditServices,
    onEditServices,
    isLoading,
  };
}

export default useServices;
